import { render } from "./ClientInventarioMarcas.vue?vue&type=template&id=18f96fac&scoped=true"
import script from "./ClientInventarioMarcas.vue?vue&type=script&lang=js"
export * from "./ClientInventarioMarcas.vue?vue&type=script&lang=js"

import "./ClientInventarioMarcas.vue?vue&type=style&index=0&id=18f96fac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f96fac"]])

export default __exports__